import ApiAuthPaths from '../../all/ApiAuthPaths'
export default ApiAuthPaths